/** PURE_IMPORTS_START .._operators_toArray PURE_IMPORTS_END */
import { toArray as higherOrder } from '../operators/toArray';
/**
 * Collects all source emissions and emits them as an array when the source completes.
 *
 * <span class="informal">Get all values inside an array when the source completes</span>
 *
 * <img src="./img/toArray.png" width="100%">
 *
 * `toArray` will wait until the source Observable completes
 * before emitting the array containing all emissions.
 * When the source Observable errors no array will be emitted.
 *
 * @example <caption>Create array from input</caption>
 * const input = Rx.Observable.interval(100).take(4);
 *
 * input.toArray()
 *   .subscribe(arr => console.log(arr)); // [0,1,2,3]
 *
 * @see {@link buffer}
 *
 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
 * @method toArray
 * @owner Observable
 */
export function toArray() {
    return higherOrder()(this);
}
//# sourceMappingURL=toArray.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/operator/toArray.js
// module id = 874
// module chunks = 0